/*
Monotype Foundry Platform API
Version 1.0.0

Definition: Settings

Properties:
  accountSettings: object
*/

var Settings = (function () {
  function validateSettings (arg) {
    // Validate accountSettings
    if (arg.accountSettings && !(typeof arg.accountSettings === 'object')) {
      throw new Error('Settings.accountSettings: Wrong type: Got \'' + (typeof arg.accountSettings) + '\', but expected: \'object\'')
    }
  }
  function buildSettings (arg) {
    var Settings = arg
    // Complete accountSettings
    // Expected Type: object
    Settings.accountSettings = Settings.accountSettings || {}
    // Complete accountSettings.graphicsPreferences
    // Expected Type: object
    Settings.accountSettings.graphicsPreferences = Settings.accountSettings.graphicsPreferences || {}
    // Complete accountSettings.pricePreferences
    // Expected Type: array
    Settings.accountSettings.pricePreferences = Settings.accountSettings.pricePreferences || []
    // Complete accountSettings.userPermissions
    // Expected Type: array
    Settings.accountSettings.userPermissions = Settings.accountSettings.userPermissions || []
    return Settings
  }
  return {
    validate: validateSettings,
    build: buildSettings
  }
})()

module.exports = Settings
